import React, { useEffect, useState } from 'react'

import { bingoPixiApplicationInit, bingoPixiAssetsLoad } from './bridge'

const BingoPixiApp = () => {
  const [isPixiAssetsLoaded, setIsPixiAssetsLoaded] = useState(false)

  useEffect(() => {
    if (!isPixiAssetsLoaded) bingoPixiAssetsLoad(setIsPixiAssetsLoaded)
    else bingoPixiApplicationInit(setIsPixiAssetsLoaded)
  }, [isPixiAssetsLoaded])

  return <div id='pixi-game' className='' />
}

export default BingoPixiApp
